module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "fm_head"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rcover"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062934864_Cover#cover"
    }
  }, [_c('i', [_vm._v("Cover")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rtitle"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062934864_Title#title"
    }
  }, [_c('i', [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062934864_Dedication#_idParaDest-1"
    }
  }, [_c('i', [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc15",
    attrs: {
      "id": "r_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_1#_idParaDest-2"
    }
  }, [_vm._v("Chapter One: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_2#_idParaDest-4"
    }
  }, [_vm._v("Chapter Two: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_3#_idParaDest-6"
    }
  }, [_vm._v("Chapter Three: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_4#_idParaDest-8"
    }
  }, [_vm._v("Chapter Four: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_5#_idParaDest-10"
    }
  }, [_vm._v("Chapter Five: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_6#_idParaDest-12"
    }
  }, [_vm._v("Chapter Six: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_7#_idParaDest-14"
    }
  }, [_vm._v("Chapter Seven: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_8#_idParaDest-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_9#_idParaDest-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_10#_idParaDest-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_11#_idParaDest-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_12#_idParaDest-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_13#_idParaDest-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_14#_idParaDest-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_15#_idParaDest-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_16#_idParaDest-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_17#_idParaDest-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_18#_idParaDest-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_19#_idParaDest-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nineteen: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_20#_idParaDest-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_21#_idParaDest-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-One: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_22#_idParaDest-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Two: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_23#_idParaDest-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Three: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_24#_idParaDest-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Four: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_25#_idParaDest-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Five: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_26#_idParaDest-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Six: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_27#_idParaDest-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Seven: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_28#_idParaDest-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Eight: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_29#_idParaDest-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Nine: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_30#_idParaDest-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_31#_idParaDest-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-One: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_32#_idParaDest-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Two: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_33#_idParaDest-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Three: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_34#_idParaDest-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Four: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_35#_idParaDest-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Five: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_36#_idParaDest-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Six: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_37#_idParaDest-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Seven: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_38#_idParaDest-76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Eight: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_39#_idParaDest-78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Nine: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_40#_idParaDest-80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_41#_idParaDest-82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-One: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_42#_idParaDest-84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Two: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-86"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_43#_idParaDest-86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Three: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-88"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_44#_idParaDest-88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Four: Tommy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-90"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_45#_idParaDest-90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Five: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-92"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_46#_idParaDest-92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Six: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-94"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_47#_idParaDest-94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Seven: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-96"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_48#_idParaDest-96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Eight: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-98"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_49#_idParaDest-98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Forty-Nine: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-100"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_50#_idParaDest-100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-102"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_51#_idParaDest-102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty-One: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-104"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_52#_idParaDest-104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty-Two: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-106"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_53#_idParaDest-106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty-Three: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-108"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_54#_idParaDest-108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty-Four: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-110"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_55#_idParaDest-110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty-Five: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-112"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_56#_idParaDest-112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty-Six: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-114"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_57#_idParaDest-114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty-Seven: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-116"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_58#_idParaDest-116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty-Eight: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-118"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_59#_idParaDest-118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifty-Nine: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-120"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_60#_idParaDest-120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixty: CeCe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-122"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Chapter_61#_idParaDest-122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixty-One: Alexis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-124"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_one_year#_idParaDest-124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("One Year Later")])]), _vm._v(" "), _c('p', {
    staticClass: "toc15",
    attrs: {
      "id": "r_idParaDest-125"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Acknowledgments#_idParaDest-125",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-126"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Ps_section#_idParaDest-126",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("P.S. Insights, Interviews & More . . .*")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l",
    attrs: {
      "id": "r_idParaDest-127"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Author#_idParaDest-127",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l",
    attrs: {
      "id": "r_idParaDest-128"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_About_the_Book#_idParaDest-128",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Book")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "nlann"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Little_Announcement#lann",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("An Excerpt from")]), _vm._v(" LITTLE PIECES OF ME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l",
    attrs: {
      "id": "nlch1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Little_Chapter_One#lch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter One")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l",
    attrs: {
      "id": "nlch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Little_Chapter_Two#lch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter Two")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_l",
    attrs: {
      "id": "nlch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Little_Chapter_Three#lch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Chapter Three")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-129"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780062934864_Copyright#_idParaDest-129",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Copyright")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "r_idParaDest-130"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/About_the_Publisher#_idParaDest-130",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c43061a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062934864_Contents.vue
// module id = 66
// module chunks = 0